var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "ui-progress-linear--transition-fade" } },
    [
      _c(
        "div",
        {
          staticClass: "ui-progress-linear",
          class: _vm.classes,
          style: {
            backgroundColor: "rgba(" + _vm.$themeTokens.loading + ", 0.4)",
          },
        },
        [
          _vm.type === "determinate"
            ? _c("div", {
                staticClass: "is-determinate ui-progress-linear-progress-bar",
                style: {
                  transform: "scaleX(" + _vm.moderatedProgress / 100 + ")",
                  backgroundColor: _vm.$themeTokens.loading,
                },
                attrs: {
                  role: "progressbar",
                  "aria-valuemax": 100,
                  "aria-valuemin": 0,
                  "aria-valuenow": _vm.moderatedProgress,
                },
              })
            : _c("div", {
                staticClass: "is-indeterminate ui-progress-linear-progress-bar",
                style: { backgroundColor: _vm.$themeTokens.loading },
                attrs: {
                  role: "progressbar",
                  "aria-valuemax": 100,
                  "aria-valuemin": 0,
                },
              }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }